import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AutomationType from "./automation-type";
import { TRIGGERS_WITH_AUTOMATION, AUTOMATIONS_BY_TRIGGER, TRIGGER_BY_KEY } from "../store/automation-getters";
import { LOAD_APPLICATION_AUTOMATIONS } from "../store/automation-actions";
import { mapState, mapGetters, mapActions } from "vuex";
import { isEmpty } from "lodash";
import DocumentLevelAutomationsLoader from "./document-level/loaders/document-level-automations-loader.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  components: {
    AutomationType,
    DocumentLevelAutomationsLoader
  },
  props: {
    level: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: true
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState("AutomationStore", {
    triggers: state => state.automationData.entities.trigger
  })), mapGetters("AutomationStore", [TRIGGERS_WITH_AUTOMATION, AUTOMATIONS_BY_TRIGGER, TRIGGER_BY_KEY])), {}, {
    triggersWithAutomationByLevel() {
      return this.TRIGGERS_WITH_AUTOMATION(this.level);
    },
    triggersEmpty() {
      return isEmpty(this.triggersWithAutomationByLevel);
    }
  }),
  async mounted() {
    const {
      selectedTemplate
    } = this.$route.params;
    if (!selectedTemplate) {
      await this.LOAD_APPLICATION_AUTOMATIONS();
    }
    this.loading = false;
  },
  methods: _objectSpread({}, mapActions("AutomationStore", [LOAD_APPLICATION_AUTOMATIONS]))
});